import React,{ useState, useEffect } from 'react';
import styled from 'styled-components';
import {NavLink} from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { useForm } from 'react-hook-form';
import { useRouteMatch } from 'react-router-dom'

// Components
import StyledPage from '../components/StyledPage';
import AuthLayoutWrapper from '../components/AuthLayoutWrapper';
import FormErrors, { trowError } from '../components/FormErrors';
import Button from '../components/Button';

import ReCAPTCHA from 'react-google-recaptcha';

import { CREATE_RECUPERAR_PASSWORD } from '../models/AcreditacionProfile';

let name = 'taylor';


export default () => {
    const [nombre, setNombre] = useState('PEPE')
    const [apellido, setApellido] = useState('DE LA O')

    
  useEffect(() => {
    console.log();
  }, []);

    
    console.log({nombre,apellido, name})

    return (
        <StyledPage>
            <p>{nombre}</p>
            <p>{apellido}</p>
            <p>{name}</p>
            <button onClick={() => name = "Swift"}>change me</button>
            <button onClick={() => setNombre('OSCAR')}>click me</button>
            <button onClick={() => setApellido('NO TENGO')}>click me 2</button>
                
        </StyledPage>
    )
};